import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/gtagUtils';

/**
 * Componente escuchador de rutas de React Router
 * Dispara el evento de seguimiento de Google Tag AW-18386242156 en cada cambio de vista.
 */
const GoogleTagRouteTracker = () => {
    const location = useLocation();

    useEffect(() => {
        // Notificar a Google Tag la nueva URL navegada en la aplicación SPA
        trackPageView(location.pathname + location.search);
    }, [location]);

    return null;
};

export default GoogleTagRouteTracker;
